import { useState } from "react";
import { toast } from "sonner";
import { Printer } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ResourceTable } from "@/components/data/ResourceTable";
import { PageHeader } from "@/components/data/StatusBadge";
import { Synthese, Consultation, InventaireLignes } from "@/components/stocks/StockViews";
import { api, errMsg } from "@/lib/api";
import { printBon } from "@/lib/export";

const TABS = [["synthese", "Synthèse & alertes"], ["mouvements", "Mouvements"], ["consultation", "Consultation"], ["inventaires", "Inventaires"],
  ["articles", "Articles"], ["unites", "Unités"], ["depots", "Dépôts"]];

const imprimer = async (row) => {
  try {
    await printBon((await api.get(`/stocks/mouvements/${row.id}/bon`)).data);
  } catch (e) {
    toast.error(errMsg(e));
  }
};

export default function StocksPage() {
  const [reload, setReload] = useState(0);
  const changed = () => setReload((n) => n + 1);
  const bonAction = (row) => [{ key: "imprimer-bon", label: "Imprimer le bon", icon: Printer, show: row.statut === "valide", onClick: imprimer }];
  return (
    <div>
      <PageHeader title="Stocks de rouleaux & bobines" subtitle="Dépôts KGD → superviseurs → revendeurs. Stocks théoriques calculés à partir des mouvements validés ; aucun stock négatif sans autorisation spécifique tracée." />
      <Tabs defaultValue="synthese">
        <TabsList className="mb-4 flex-wrap h-auto">
          {TABS.map(([v, l]) => <TabsTrigger key={v} value={v} data-testid={`tab-stock-${v}`}>{l}</TabsTrigger>)}
        </TabsList>
        <TabsContent value="synthese"><Synthese reloadKey={reload} /></TabsContent>
        <TabsContent value="mouvements"><ResourceTable res="stock_mouvements" extraActions={bonAction} reloadKey={reload} onChanged={changed} /></TabsContent>
        <TabsContent value="consultation"><Consultation reloadKey={reload} /></TabsContent>
        <TabsContent value="inventaires">
          <ResourceTable res="stock_inventaires" reloadKey={reload} onChanged={changed} detailExtra={(row) => <InventaireLignes row={row} onSaved={changed} />} />
        </TabsContent>
        <TabsContent value="articles"><ResourceTable res="stock_articles" reloadKey={reload} onChanged={changed} /></TabsContent>
        <TabsContent value="unites"><ResourceTable res="stock_unites" onChanged={changed} /></TabsContent>
        <TabsContent value="depots"><ResourceTable res="stock_depots" onChanged={changed} /></TabsContent>
      </Tabs>
    </div>
  );
}
